import GoogleMapReact from "google-map-react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { Grid, Paper } from "@material-ui/core";

import { selectInformation } from "../../Stores/informationSlice";
import BackgroundImage from "../Common/BackgroundImage/BackgroundImage";
import Loading from "../Loading/Loading";

import { ParkingInfoStyles } from "./ParkingInfoStyles";

const ParkingInfo = () => {
  const classes = ParkingInfoStyles();
  const { t } = useTranslation();
  const information = useSelector(selectInformation);
  function createCenterControl() {
    const controlButton = document.createElement("button");

    // Set CSS for the control.
    controlButton.style.backgroundColor = "#fff";
    controlButton.style.border = "2px solid #fff";
    controlButton.style.borderRadius = "3px";
    controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlButton.style.color = "rgb(25,25,25)";
    controlButton.style.cursor = "pointer";
    controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
    controlButton.style.fontSize = "16px";
    controlButton.style.lineHeight = "38px";
    controlButton.style.margin = "8px 0 22px";
    controlButton.style.padding = "0 5px";
    controlButton.style.textAlign = "center";

    controlButton.textContent = "Direction";
    controlButton.title = "Click to recenter the map";
    controlButton.type = "button";

    // Setup the click event listeners: simply set the map to Chicago.
    controlButton.addEventListener("click", () => {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${information?.parkingLatitude},${information?.parkingLongitude}`,
        "_blank",
        "noopener,noreferrer"
      );
    });
    controlButton.addEventListener("touchstart", () => {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${information?.parkingLatitude},${information?.parkingLongitude}`,
        "_blank",
        "noopener,noreferrer"
      );
    });
    return controlButton;
  }
  const renderMarkers = (map: any, maps: any) => {
    let marker = new maps.Marker({
      position: {
        lat: information?.parkingLatitude,
        lng: information?.parkingLongitude,
      },
      map,
    });
    marker.addListener("click", () => {
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${information?.parkingLatitude},${information?.parkingLongitude}`,
        "_blank",
        "noopener,noreferrer"
      );
    });
    return marker;
  };

  if (!information) return <Loading />;
  return (
    <>
      {information.themeDisplay !== "1" && <BackgroundImage />}
      <Grid container justifyContent="center" className={classes.parkingInfo}>
        {information.parkingLatitude && information.parkingLongitude && (
          <Grid item xs={12} md={6} className="gridItem">
            <Paper className="map">
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyDox6EsX_YHjshqbtw2zyeCf4ASLrDx-8Q",
                }}
                defaultCenter={{
                  lat: information.parkingLatitude,
                  lng: information.parkingLongitude,
                }}
                defaultZoom={14}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map, maps }) => {
                  renderMarkers(map, maps);
                  // Create the DIV to hold the control.
                  const centerControlDiv = document.createElement("div");
                  // Create the control.
                  const centerControl = createCenterControl();
                  // Append the control to the DIV.
                  centerControlDiv.appendChild(centerControl);

                  map.controls[maps.ControlPosition.TOP_CENTER].push(
                    centerControlDiv
                  );
                }}
              />
            </Paper>
          </Grid>
        )}

        {information.parking && (
          <Grid item xs={12} md={6} className="gridItem">
            <Paper className="paper">
              <h4>{t("parking")}</h4>
              <div dangerouslySetInnerHTML={{ __html: information.parking }} />
            </Paper>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default ParkingInfo;
